<template>
    <div class="spinner-border text-primary" role="status" style="width:1rem; height:1rem;">
        <span class="sr-only" v-if="sr">{{sr}}</span>
    </div>
</template>
<script>
export default {
    props: {
        sr: {
            type: String
        }
    }
}
</script>
